import View from './AccountForm';
import enhancer from './AccountForm.enhancer';

const AccountForm = enhancer(View);

export default AccountForm;
